import React from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';

const GOOGLE_MAPS_API_KEY = "AIzaSyDIIXS_sb-vkHEMBdo_5i16y8vFOWGLjDw"

const containerStyle = {
  position: 'relative',
  width: '100%',
  height: '100%'
}

const MapContainer = ({ google }: any) => {
  return (
    <div className="mt-10 h-[400px] w-full" >
      {/*  @ts-ignore */}
      <Map
        containerStyle={containerStyle}
        style={{
          height: 400
        }}
        google={google}
        initialCenter={{
          lat: 40.2677604,
          lng: -7.4948412
        }}
        // @ts-ignore
        zoom={15}>


        <Marker
          // @ts-ignore
          position={{
            lat: 40.2677604,
            lng: -7.4948412
          }} />
      </Map>
    </div>

  );
};

export default GoogleApiWrapper({
  apiKey: GOOGLE_MAPS_API_KEY
})(MapContainer);
